import { client } from "../gqlClient";
import {
  ADD_FEATURED_PLAYLIST,
  ADD_FEATURED_STUDIO_CLASS,
  REMOVE_FEATURED_PLAYLIST,
  REMOVE_FEATURED_STUDIO_CLASS,
  UPDATE_FEATURED_PLAYLISTS_ORDER,
  UPDATE_FEATURED_CLASSES_ORDER,
  GET_FEATURED_CLASSES,
  GET_FEATURED_PLAYLISTS,
} from "./schema";

export interface FeaturedOrderInput extends Record<string, any> {
  items: string[];
}

export async function getFeaturedClasses() {
  const data = await client.query(
    GET_FEATURED_CLASSES,
    {},
    "getFeaturedClasses",
    "network-only"
  );

  if (!data) {
    return { data: [] };
  }

  return {
    data,
  };
}

export async function getFeaturedPlaylists() {
  const data = await client.query(
    GET_FEATURED_PLAYLISTS,
    {},
    "getFeaturedPlaylists",
    "network-only"
  );

  if (!data) {
    return { data: [] };
  }

  return {
    data,
  };
}

export async function addFeaturedPlaylist({ id }: { id: string }) {
  const result = await client.mutate(ADD_FEATURED_PLAYLIST, { id });
  return { data: result.addFeaturedPlaylist };
}

export async function addFeaturedStudioClass({ id }: { id: string }) {
  const result = await client.mutate(ADD_FEATURED_STUDIO_CLASS, { id });
  return { data: result.addFeaturedStudioClass };
}

export async function removeFeaturedPlaylist({ id }: { id: string }) {
  const result = await client.mutate(REMOVE_FEATURED_PLAYLIST, { id });
  return { data: result.removeFeaturedPlaylist };
}

export async function removeFeaturedStudioClass({ id }: { id: string }) {
  const result = await client.mutate(REMOVE_FEATURED_STUDIO_CLASS, { id });
  return { data: result.removeFeaturedStudioClass };
}

export async function updateFeaturedPlaylistsOrder({
  items,
}: FeaturedOrderInput) {
  const result = await client.mutate(UPDATE_FEATURED_PLAYLISTS_ORDER, {
    items,
  });
  return { data: result.updateFeaturedPlaylistsOrder };
}

export async function updateFeaturedClassesOrder({
  items,
}: FeaturedOrderInput) {
  const result = await client.mutate(
    UPDATE_FEATURED_CLASSES_ORDER,
    { items },
    "updateFeaturedClassesOrder"
  );
  return { data: result };
}
